import React from 'react';
import { Box } from '@leap4/frontend';
import { SelectableChip } from './SelectableChip';
import { REPORT_METRICS } from '../report.constants';

interface MetricsSelectorProps {
  selectedMetrics: string[];
  onToggle: (metric: string) => void;
}

export const MetricsSelector: React.FC<MetricsSelectorProps> = ({ selectedMetrics, onToggle }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, maxWidth: '850px' }}>
      {REPORT_METRICS.map((metric) => (
        <SelectableChip
          key={metric.key}
          label={metric.label}
          selected={selectedMetrics.includes(metric.key)}
          onClick={() => onToggle(metric.key)}
        />
      ))}
    </Box>
  );
};
